import { Box, Typography } from '@mui/material';
import React from 'react';

const CenteredMessageBox = ({ message }: { message: string }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="calc(100vh - 5vh - 64px)"
    paddingBottom="5vh"
    overflow="auto"
  >
    <Typography variant="h4">{message}</Typography>
  </Box>
);

export default CenteredMessageBox;
